"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=require("./index102.js");var e=n.mathTrunc,u=function(t){var r=+t;return r!==r||r===0?0:e(r)};exports.toIntegerOrInfinity=u;
